import Workspaces from '#/containers/Workspaces'
import WorkspaceList from '#/containers/Workspaces/WorkspaceList'

const WorkspacesFavorites: React.FC = () => (
  <Workspaces>
    <WorkspaceList listId='favorites' />
  </Workspaces>
)

export default WorkspacesFavorites
export { getServerSideProps } from '#/utils/page_wrapper'
